import { render, staticRenderFns } from "./OS.vue?vue&type=template&id=32f4d06b&scoped=true&"
import script from "./OS.vue?vue&type=script&lang=js&"
export * from "./OS.vue?vue&type=script&lang=js&"
import style0 from "./OS.vue?vue&type=style&index=0&id=32f4d06b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4d06b",
  null
  
)

export default component.exports